module.exports = __webpack_public_path__ + "img/sinus-screen-new.794be836.jpg";